"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusNodeMesh = void 0;
const nexus_node_1 = require("./nexus-node");
class NexusNodeMesh {
    constructor() {
        // Status of the mesh and texture of the node
        this.status = nexus_node_1.NexusNodeDataStatus.ABSENT;
        // The reference to buffers in web gl. Used for removal.
        this.verticesGlBuffer = null;
        this.indicesGlBuffer = null;
    }
}
exports.NexusNodeMesh = NexusNodeMesh;
